export const contact = [
  {
    name: "NSW - Warehouse",
    street: "45 Justin Street Smithfield",
    city: "Sydney, NSW 2164",
    email: "NSW@priceworth.com.au",
    phone: "0415 131 824",
  },
  {
    name: "NSW - Showroom & Warehouse",
    street: "146-152 Cleveland St Chippendale",
    city: "Sydney, NSW 2008",
    email: "NSW@priceworth.com.au",
    phone: "02 9698 3198",
  },
  {
    name: "VIC - Showroom & Warehouse",
    street: "177 Henty Street Reservoir",
    city: "Melbourne, VIC 3073",
    email: "VIC@priceworth.com.au",
    phone: "0425 898 876",
    assistanceHours: [
      { weekday: "Monday - Saturday", time: "8:30 am to 17:00 pm AEST" },
    ],
  },
  {
    name: "QLD - Showroom & Warehouse",
    street: "682 Beaudesert Rd Rocklea",
    city: "Brisbane, QLD 4106",
    email: "QLD@priceworth.com.au",
    phone: "(07) 3706 5769",
    assistanceHours: [
      { weekday: "Monday – Tuesday", time: "8:00 am to 18:00 pm AEST" },
      { weekday: "Thursday – Friday", time: "8:00 am to 18:00 pm AEST" },
      { weekday: "Saturday", time: "8:30 am to 17:00 pm AEST" },
    ],
  },
];
